import { useState, useCallback } from 'react'
import * as Api from 'apps/fleet-planner/utils/api'
import { IShipmentOffer } from '../types'

interface IUseShipmentOffersState {
  error?: string
  shipmentOffers: IShipmentOffer[]
  isLoading: boolean
  getShipmentOffers: () => Promise<IShipmentOffer[] | undefined>
  declineShipmentOffer: (shipmentId: number) => Promise<number | undefined>
  findShipmentOffer: (shipmentId: number) => IShipmentOffer | undefined
}

export const useShipmentOffersApiDeprecated = (): IUseShipmentOffersState => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shipmentOffers, setShipmentOffers] = useState<IShipmentOffer[]>([])
  const [error, setError] = useState<string>('')

  const getShipmentOffers = useCallback(async (): Promise<IShipmentOffer[] | undefined> => {
    setError('')
    setIsLoading(true)
    try {
      const { offeredShipments } = await Api.fetchShipmentOffers()
      setShipmentOffers(offeredShipments)
      setIsLoading(false)
      return offeredShipments
    } catch (e) {
      setError(e)
      setIsLoading(false)
      return undefined
    }
  }, [])

  const declineShipmentOffer = useCallback(async (shipmentId: number): Promise<
    number | undefined
  > => {
    setError('')
    setIsLoading(true)
    try {
      const { shipment } = (await Api.declineShipmentOffer(shipmentId)) || {}
      const { id } = shipment || {}
      setIsLoading(false)
      return id
    } catch (e) {
      setError(e)
      setIsLoading(false)
      return undefined
    }
  }, [])

  const findShipmentOffer = useCallback(
    (shipmentId: number): IShipmentOffer | undefined => {
      return shipmentOffers.find(shipmentOffer => shipmentOffer.externalId === shipmentId)
    },
    [shipmentOffers]
  )

  return {
    error,
    shipmentOffers,
    isLoading,
    getShipmentOffers,
    declineShipmentOffer,
    findShipmentOffer,
  }
}
